/** Releases as /api/production/releases returns them. */

export type ReleaseStatus = 'draft' | 'released' | 'withdrawn';
export type ReleaseChannel = 'stable' | 'beta';

export interface ReleaseBuild {
  id: string;
  platform: 'windows' | 'linux' | 'macos';
  codeSigned: boolean;
  fileSizeBytes: string;
  cloudfrontUrl: string;
  fileHashSha256: string;
  publishedAt: string;
  /** Null when CI registered it. */
  publishedBy: string | null;
}

export interface Release {
  id: string;
  versionNumber: string;
  releaseChannel: ReleaseChannel;
  title: string | null;
  summary: string | null;
  releaseNotes: string | null;
  knownIssues: string | null;
  mandatory: boolean;
  minSupportedVersion: string | null;
  status: ReleaseStatus;
  releasedAt: string | null;
  releasedBy: { id: string; name: string } | null;
  createdAt: string;
  updatedAt: string;
  updatedBy: { id: string; name: string } | null;
  builds: ReleaseBuild[];
}

export interface ReleaseListQuery {
  limit: number;
  offset: number;
  channel?: ReleaseChannel;
  status?: ReleaseStatus;
}

/** Only what changed; null clears a text field. */
export interface UpdateReleaseRequest {
  title?: string | null;
  summary?: string | null;
  releaseNotes?: string | null;
  knownIssues?: string | null;
  mandatory?: boolean;
  minSupportedVersion?: string | null;
}

export interface Announcement {
  versionNumber: string;
  channel: ReleaseChannel;
  status: ReleaseStatus;
  recipients: number;
  previous: { sentAt: string; sentBy: string; count: number } | null;
}

export const PLATFORM_LABEL: Record<ReleaseBuild['platform'], string> = {
  windows: 'Windows',
  linux: 'Linux',
  macos: 'macOS',
};
